import React, { useMemo } from 'react';
import { LinkUniversal } from '@duxton-web/icons';
import { Card, ConfigProvider, Tabs, Typography } from '@duxton-web/ui';

import AccessControlTable from './access-control-table';
import PermissionMatrix from './permission-matrix';

import './index.css';

export const AccessControl = () => {
  const tabItems = useMemo(
    () => [
      {
        key: 'access-table',
        label: 'Access Table',
        children: <AccessControlTable />,
      },
      {
        key: 'permission-matrix',
        label: 'Permission Matrix',
        children: <PermissionMatrix />,
      },
    ],
    [],
  );

  const typographyTheme = useMemo(
    () => ({
      components: {
        Typography: {
          titleMarginBottom: 0,
        },
      },
    }),
    [],
  );

  return (
    <div className="access-control">
      <ConfigProvider theme={typographyTheme}>
        <Typography.Title level={3}>Access Control</Typography.Title>
      </ConfigProvider>

      <ul className="access-control-guide">
        <li>
          There is a&nbsp;
          <a
            href="https://go/grabx-access-request"
            target="_blank"
            rel="noreferrer"
          >
            guide <LinkUniversal />
          </a>
          &nbsp;which can help you to understand how to raise request
        </li>
      </ul>

      <Card className="access-control-card">
        <Tabs defaultActiveKey="access-table" size="small" items={tabItems} />
      </Card>
    </div>
  );
};

export default AccessControl;
